<template>
  <div class="coloris"
       :style="{backgroundColor: color, pointerEvents: disabled ? 'none' : null}"
  >
    <input
        ref="inputRef"
        :value="color"
        type="text"
        data-coloris
        @input="onChange"
    />
  </div>
</template>
<script setup>
import {ref, watch} from "vue";

//todo: fix bug with current color is not selected on picker
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: String,
  disabled: Boolean,
  theme: {
    type: String,
    default: 'default'
  }
});
defineExpose({
  open,
})
const color = ref(props.modelValue);
const inputRef = ref();

watch(() => color.value, (value) => emit('update:modelValue', value));
watch(() => props.modelValue, (value) => color.value = value);

function onChange(e) {
  color.value = e.target.value;
}

function open() {
  inputRef.value.click();
}
</script>
<style lang="scss">
.coloris {
  position: relative;
  overflow: hidden;

  > input {
    opacity: 0 !important;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.clr-picker {
  z-index: 9999 !important;
}
</style>